/*
**
constants
**
*/

const vehicleDocumentStatus = {
    NOT_UPLOADED: 0,
    APPROVED: 1,
    PENDIND: 2,
    REJECTED: 3
}
const vehicleStatus = {
    PENDIND: 0,
    APPROVED: 1,
    REJECTED: 2
}

const driverVerificationStatus = {
    NOT_UPLOADED: -1,
    APPROVED: 1,
    PENDIND: 0,
    REJECTED: 2
}

const gender = {
    MALE: 1,
    FEMALE: 2,
    OTHERS: 3,
    NOT_KNOWN: 0
}

exports.VehicleTypes = {
    1: "Taxi",
    2: "Bike",
    3: "Autos"
};

exports.DocumentTypes = {
    1: "Driver Document"
};

exports.paymentMethod2 = {
    1: "RazorPay",
    2: "Stripe"
}

exports.panelRoles = {
    SUPERADMIN : 1,
    ADMIN      : 2,
    FLEET      : 3
}

exports.SidebarTabs = {
    USER: 1,
    VEHICLE: 2,
    DRIVER_DOCUMENTS: 3,
    HOMESCREEN: 4,
    FLEETS: 5,
    MANAGER_SETTINGS: 6,
    GEOFENCE: 7,
    CORPORATE: 8,
    RIDES:9,
    ANALYTICS:10,
    SURGEPRICING: 11

};

exports.dispatchTypeConst = {
    0: "Delayed",
    1: "Instant",
    2: "Instant and Delayed"
}

exports.WeekdaysConst = {
    MON: 1,
    TUE: 2,
    WED: 3,
    THUR: 4,
    FRI: 5,
    SAT: 6,
    SUN: 7
}

exports.CustomZoneTypeConst = {
    1: "Toll",
    2: "AIRPORT (Pickup or Drop)",
    3: "CONGESTION (Pickup or Drop)"
}

exports.customZoneCharge = [1, 2, 3];

exports.panelengagmentStatus = {
    ONGOING: 1,
    COMPLETED: 2,
    CANCELLED: 3,
    MISSED: 4
}
exports.API_KEY = "AIzaSyB9PP9WVCovkYUaRZu3S-ts5sDExixgLsg"

exports.paymentMode = {
    1: "CASH",
    2: "STRIPE"
}